import React, { useState } from 'react';
import { fmtTool } from './utils';

interface RetryCardProps {
  payload: any;
  runId: string;
  isPending: boolean;
  confirmed?: boolean;
  onConfirmAction: (id: string, confirmed: boolean) => void;
  onSkipAction: (id: string) => void;
  onRetryAction: (id: string, parsedArgs: any) => void;
  retryArgsText: any;
  setRetryArgsText: any;
}

export default function RetryCard({
  payload,
  runId,
  isPending,
  confirmed,
  onConfirmAction,
  onSkipAction,
  onRetryAction,
  retryArgsText,
  setRetryArgsText,
}: RetryCardProps) {
  const errTool = payload?.tool ?? '';
  const errStep = payload?.step ?? 0;
  const errTotal = payload?.total ?? 0;
  const errMsg = payload?.error ?? '';
  const errArgs = payload?.args ?? {};
  
  const argsKey = runId;
  // Initialize from props if it exists, otherwise use stringified args
  const [localArgsText, setLocalArgsText] = useState(
    retryArgsText[argsKey] ?? JSON.stringify(errArgs, null, 2)
  );

  let parsedArgs: any = null;
  let parseError = false;
  try { 
    parsedArgs = JSON.parse(localArgsText); 
  } catch { 
    parseError = true; 
  }

  const handleChange = (val: string) => {
    setLocalArgsText(val);
    setRetryArgsText((prev: any) => ({ ...prev, [argsKey]: val }));
  };

  return (
    <div className="bx-retry-card">
      {isPending ? (
        <>
          <div className="bx-retry-header">
            <span className="bx-retry-icon">✗</span>
            <span className="bx-retry-tool">{fmtTool(errTool)}</span>
            <span className="bx-retry-counter">{errStep}/{errTotal}</span>
          </div>
          <div className="bx-retry-error">{errMsg}</div>
          <div className="bx-retry-args-label">Parameters sent to API:</div>
          <textarea
            className="bx-retry-args-editor"
            value={localArgsText}
            onChange={e => handleChange(e.target.value)}
            rows={Math.min(12, localArgsText.split('\n').length + 1)}
            spellCheck={false}
          />
          {parseError && <div className="bx-retry-parse-err">Invalid JSON — fix before retrying</div>}
          <div className="bx-retry-actions">
            <button className="bx-confirm-reject bx-retry-cancel" onClick={() => onConfirmAction(runId, false)}>
              Cancel
            </button>
            <button className="bx-retry-skip" onClick={() => onSkipAction(runId)}>
              Skip step
            </button>
            <button
              className="bx-confirm-accept bx-confirm-accept--full"
              disabled={parseError}
              style={parseError ? { opacity: 0.4, cursor: 'not-allowed' } : {}}
              onClick={() => !parseError && onRetryAction(runId, parsedArgs)}
            >
              Retry
            </button>
          </div>
        </>
      ) : (
        <div className={`bx-confirm-result${confirmed ? ' bx-confirm-result--accepted' : ' bx-confirm-result--rejected'}`}>
          {confirmed ? '↻ Retrying…' : '✗ Execution cancelled'}
        </div>
      )}
    </div>
  );
}
